import React from 'react';
import { Link } from 'react-router-dom';
import { Result, Button } from 'antd';

const NotFoundPage: React.FC = () => (
  <Result
    status="404"
    title="404 - Not Found"
    subTitle="Sorry, the page you visited does not exist."
    extra={
      <Button type="primary">
        <Link to="/app">Go to Dashboard</Link>
      </Button>
    }
  />
);

export default NotFoundPage;
